import { findTexture } from 'mc_pixi-fiber'
import { Container, Sprite } from 'pixi.js'
import { Tween, Easing } from "@tweenjs/tween.js"

import SymbolScales from "./SymbolScales"

const WR_FS = "WR_FS"
const TWEEN_DURATION = 250

//don't go searching for textures all the time
let normalSymbolTextureCache = {}
function getNormalSymbolTexture(key) {
    if (normalSymbolTextureCache[key]) {
        return normalSymbolTextureCache[key]
    }

    normalSymbolTextureCache[key] = findTexture(`reel/symbols/normal/${key}`)
    return normalSymbolTextureCache[key]
}

let blurredSymbolTextureCache = {}
function getBlurredSymbolTexture(key) {
    if (blurredSymbolTextureCache[key]) {
        return blurredSymbolTextureCache[key]
    }

    blurredSymbolTextureCache[key] = findTexture(`reel/symbols/blurred/${key}`)
    return blurredSymbolTextureCache[key]
}

export default class Symbol extends Container {
    constructor(symbolInfo) {
        super()

        this.getNormalSymbolTexture = getNormalSymbolTexture
        this.getBlurredSymbolTexture = getBlurredSymbolTexture

        this.symbolInfo = symbolInfo
        this.setup()
        this.currentScale = SymbolScales[this.key]
    }

    setup() {
        const { symbolInfo } = this

        const texture = getNormalSymbolTexture(symbolInfo)
        this.sprite = new Sprite(texture)
        this.addChild(this.sprite)

        this.key = symbolInfo
    }

    blur() {
        const { key, sprite } = this
        sprite.texture = getBlurredSymbolTexture(key)
    }

    unblur() {
        const { key, sprite } = this
        sprite.texture = getNormalSymbolTexture(key)
    }

    update(size) {
        this.updateSprite(size)
        this.size = size
    }

    turnWild() {
        const { sprite, currentScale, size } = this
        const scaleObject = { scale: currentScale }

        const tweenDown = new Tween(scaleObject)
            .to({ scale: 0 }, TWEEN_DURATION)
            .easing(Easing.Quadratic.Out)
            .onUpdate(() => {
                this.currentScale = scaleObject.scale
                this.updateSprite(size)
            })
            .onComplete(() => {
                this.key = WR_FS
                this.unblur()
            })

        const tweenUp = new Tween(scaleObject)
            .to({ scale: SymbolScales.WR_FS }, TWEEN_DURATION)
            .easing(Easing.Elastic.Out)
            .onUpdate(() => {
                this.currentScale = scaleObject.scale
                this.updateSprite(size)
            })

        tweenDown.chain(tweenUp).start()
    }

    updateSprite(size) {
        const { sprite, currentScale } = this
        const { texture } = sprite
        const { width, height } = size

        sprite.anchor.set(0.5, 0.5)
        sprite.width = width * currentScale
        sprite.scale.y = sprite.scale.x
    }
}
